import React, { useState, useEffect } from "react"
import { Menu, Icon, Button, Modal } from "antd"
import { connect } from "react-redux"
import MainActions from "redux-store/models/main"
import AuthActions from "redux-store/models/auth"
import images from "../../../themes/images"
import { get, isEmpty } from "lodash"
import { withRouter } from "react-router-dom"
import "./AdminMenu.css"
import { baseUrlImg } from "../../../config/api"
import { useCustomerly } from "react-live-chat-customerly"
import OtpInput from "../adminModals/DepositoModal/OtpInput"
import TwoFactorSetupModal from "../OtpModal/TwoFactorSetupModal"

const { SubMenu } = Menu

const AdminMenu = (props) => {
  const {
    skinList,
    setActiveSkinId,
    setActiveSkinName,
    history,
    accountInfo,
    activeSkinId,
    activeSkinName,
    logOut,
    menuSkinVisible,
  } = props

  const isMrPayCard = process.env.REACT_APP_IS_MRPAY_CARD === "true"
  const skinName = localStorage.getItem("skin_name") || ""

  const [selectedNavKey, setSelectedNavKey] = useState([])
  const [selectedSkinKey, setSelectedSkinKey] = useState([])
  const [show2FA, setShow2Fa] = useState(false)

  const role = get(accountInfo, "profile.role.name")

  const agentSkin = localStorage.getItem("skin_name")
  // Menu items
  let menuItems = [
    {
      key: "providers",
      path: "/back-office/providers",
      icon: <img src={require("../../../assets/images/icons/providers.svg")} />,
      label: "Providers",
      roles: ["main_admin"],
    },
    {
      key: "reg-agenzia",
      path: "/back-office/registraAgenzia",
      icon: <Icon type="plus" />,
      label: "Registra Agenzia",
      roles: ["super_admin", "agent"],
    },
    {
      key: "reg-agente",
      path: "/back-office/registraAgente",
      icon: <Icon type="plus" />,
      label: "Registra Agente",
      roles: ["super_admin"],
    },
    {
      key: "servizi",
      path: "/back-office/servizi",
      icon: <img src={require("../../../assets/images/icons/shop.svg")} />,
      label: "Servizi",
      roles: ["main_admin"],
    },
    {
      key: "categorie",
      path: "/back-office/category",
      icon: <img src={require("../../../assets/images/icons/category.svg")} />,
      label: "Categorie",
      roles: ["main_admin"],
    },
    {
      key: "gallery",
      path: "/back-office/gallery",
      icon: <img src={require("../../../assets/images/icons/gallery.svg")} />,
      label: "Media",
      roles: ["main_admin", "support"],
    },
    {
      key: "dropshipping",
      path: "/back-office/ordine-shop",
      icon: <img src={require("../../../assets/images/icons/dropshipping.svg")} />,
      label: "Dropshipping",
      roles: ["main_admin"],
    },
    {
      key: "finanziario-section",
      label: "Finanziario",
      isSection: true,
      roles: ["main_admin", "super_admin", "agent", "support"],
    },
    {
      key: "payment",
      path: "/back-office/movimenti",
      icon: <img src={require("../../../assets/images/icons/payment.svg")} />,
      label: "Movimenti",
      roles: ["main_admin", "super_admin", "agent", "support"],
    },
    {
      key: "reports",
      path: "/back-office/reports",
      icon: <img src={require("../../../assets/images/icons/statistiche.svg")} />,
      label: "Reports",
      roles: ["main_admin", "super_admin"],
    },
    // {
    //   key: "mrpay-card",
    //   path: "/back-office/mrpay-card",
    //   icon: <img src={require("../../../assets/images/icons/shop.svg")} />,
    //   label: "MrPay Card",
    //   roles: ["main_admin", "super_admin"],
    // },
    {
      key: "utenti",
      path: "/back-office/utenti",
      icon: <img src={require("../../../assets/images/icons/users.svg")} />,
      label: "Utenti",
      roles: ["main_admin", "super_admin", "agent", "support"],
    },
    {
      key: "listino",
      path: "/back-office/listino",
      icon: <img src={require("../../../assets/images/icons/category.svg")} />,
      label: "Listino",
      roles: ["main_admin"],
    },
    {
      key: "statistiche",
      path: "/back-office/statistiche",
      icon: <img src={require("../../../assets/images/icons/statistiche.svg")} />,
      label: "Statistiche",
      roles: ["main_admin", "super_admin", "agent", "support"],
    },
    {
      key: "depositi-prelievi",
      path: "/back-office/depositi",
      icon: <img src={require("../../../assets/images/icons/depositi.svg")} />,
      label: "Depositi/Prelievi",
      roles: ["main_admin", "super_admin"],
    },
    {
      key: "fatture",
      path: "/back-office/fatture",
      icon: <img src={require("../../../assets/images/icons/fatture.svg")} />,
      label: "Fatture",
      roles: ["main_admin", "super_admin", "agent"],
    },
    {
      key: "sospeso",
      path: "/back-office/pending-payments",
      icon: <img src={require("../../../assets/images/icons/statistiche.svg")} />,
      label: "Pagamenti in sospeso",
      roles: ["main_admin", "support"],
    },
     {
      key: "failed-payments",
      path: "/back-office/failed-payments",
      icon:  <Icon type="close-circle" />,
      label: "Esito dubbio",
      roles: ["main_admin", "support"],
    },
    {
      key: "fintech",
      path: "/back-office/fintech",
      icon: <img src={require("../../../assets/images/icons/providers.svg")} />,
      label: "Connect Fintech",
      roles: ["main_admin", "support"],
    },

    {
      key: "mrshop-section",
      label: "MrShop E‑Commerce",
      isSection: true,
      roles: ["main_admin"],
    },
    {
      key: "attributes",
      icon: <img src={require("../../../assets/images/icons/category.svg")} />,
      label: "Attributes",
      roles: ["main_admin"],
      path: "/back-office/attributes",
    },
    {
      key: "products",
      icon: <img src={require("../../../assets/images/icons/shop.svg")} />,
      label: "Products",
      roles: ["main_admin"],
      path: "/back-office/products",
    },
    {
      key: "generale-section",
      label: "Generale",
      isSection: true,
      roles: ["main_admin", "super_admin", "agent"],
    },
    {
      key: "support",
      icon: <img src={require("../../../assets/images/icons/support.svg")} />,
      label: "Support",
      roles: ["main_admin", "super_admin", "agent"],
      onClick: () => handleOpenChat(),
    },
    {
      key: "errori",
      path: "/back-office/support",
      icon: <img src={require("../../../assets/images/icons/error.svg")} />,
      label: "Errori",
      roles: ["main_admin", "support"],
    },

    {
      key: "messaggi",
      path: "/back-office/messaggi",
      icon: <img src={require("../../../assets/images/icons/message.svg")} />,
      label: "Messaggi",
      roles: ["main_admin", "super_admin", "agent"],
    },
    {
      key: "panic-mode",
      path:
        role === "main_admin" ? "/back-office/configure" : "/back-office/configura",
      icon:
        role === "main_admin" ? (
          <img src={require("../../../assets/images/icons/panic-mode.svg")} />
        ) : (
          <Icon type={role === "main_admin" ? "safety" : "user"} />
        ),
      label: role === "main_admin" ? "Panic Mode" : "Dati Utente",
      roles: ["main_admin", "super_admin", "agent", "support"],
    },
    {
      key: "documentazione",
      onClick: () => window.open("https://pos.mrpay.it/swagger"),
      icon: <Icon type="file" size={10} />,
      label: "Documentazione",
      roles: ["main_admin", "super_admin"],
    },
    {
      key: "add-skin",
      path: "/back-office/CreateSkin",
      icon: <Icon type="plus" />,
      label: "Aggiungi skin",
      roles: ["main_admin"],
    },
    {
      key: "enable-2fa",
      onClick: () => handleOpen2FA(),
      icon: <Icon type="qrcode" />,
      label: "Enable 2FA",
      roles: ["main_admin", "super_admin", "agent", "support"],
    },
    // {
    //   key: "logout",
    //   path: "/logout",
    //   icon: <Icon type="logout" />,
    //   label: "Log out",
    //   roles: ["main_admin", "super_admin", "agent", "support"],
    //   onClick: () => handleLogout(),
    // },
  ]

  if (isMrPayCard) {
    menuItems = menuItems.filter(
      (item) =>
        !["providers", "categorie", "dropshipping", "depositi-prelievi"].includes(
          item.key,
        ),
    )
  }

  const handleLogout = () => {
    logOut()
    window.location.hash = "login"
  }

  const { load, open, update } = useCustomerly()

  useEffect(() => {
    if (isEmpty(accountInfo)) {
      load({})

      localStorage.removeItem("customerly_messenger/chatflows")
      localStorage.removeItem("customerly_messenger/fakeConversations")
      localStorage.removeItem("customerly_messenger/i18next/en-translation")
      localStorage.removeItem("customerly_messenger/i18next/it-translation")
      localStorage.removeItem("customerly_messenger/stats")
      document.cookie =
        "customerly_jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
    } else {
      const userOptions = {
        user_id: get(accountInfo, "profile.id"),
        name: get(accountInfo, "profile.name"),
        email: get(accountInfo, "profile.email"),
      }
      load(userOptions)
      update(userOptions)
    }
  }, [accountInfo])

  useEffect(() => {
    if (!isEmpty(accountInfo)) {
      const userOptions = {
        user_id: get(accountInfo, "profile.id"),
        name: get(accountInfo, "profile.name"),
        email: get(accountInfo, "profile.email"),
      }
      update(userOptions)
    } else update()
  }, [accountInfo])

  const handleOpenChat = () => {
    open()
  }

  const handleOpen2FA = () => {
    setShow2Fa(true)
  }

  const accessibleMenuItems = menuItems.filter((item) => item.roles.includes(role))

  useEffect(() => {
    if (skinList?.length > 0) {
      const firstSkin = skinList[0]

      const newSkinId = activeSkinId !== "-1" ? activeSkinId : firstSkin.id
      // setActiveSkinId(newSkinId)
      setActiveSkinName(
        activeSkinId === -1
          ? ""
          : activeSkinName
            ? activeSkinName
            : firstSkin.username,
      )
      setSelectedSkinKey([newSkinId?.toString()])
    }
  }, [skinList, activeSkinId])

  useEffect(() => {
    const currentPath = history.location.pathname
    const activeItem = menuItems.find((item) => currentPath.startsWith(item.path))

    if (activeItem) {
      setSelectedNavKey([activeItem.key])
    } else {
      setSelectedNavKey([])
    }
  }, [history.location.pathname])

  const handleNavigation = (path) => {
    history.push(path)
    const activeItem = menuItems.find((item) => item.path === path)
    if (activeItem) {
      setSelectedNavKey([activeItem.key])
    }
  }

  const returnLogo = (id) => {
    return require(`../../../assets/images${id}/logo.svg`)
  }

  const handleClickSkin = (skin, e) => {
    const key = e.key

    setActiveSkinId(activeSkinId === skin.id ? -1 : skin.id)
    setActiveSkinName(skin.username)

    setSelectedSkinKey((prevSelectedKeys) => {
      if (prevSelectedKeys[0] === key) {
        return []
      } else {
        return [key]
      }
    })
  }

  return (
    <>
      <TwoFactorSetupModal open={show2FA} onOpenChange={() => setShow2Fa(false)} />
      <div className="admin-menu">
        <div>
          <div className="menu-logo">
            <a href="/#/back-office/utenti">
              {role != "support" && role != "main_admin" && (
                <>
                  <img
                    className={
                      "imageHeaderTitle " + accountInfo.profile.activity_name
                    }
                    src={
                      menuSkinVisible
                        ? `${baseUrlImg}/icon/${agentSkin}-icon.svg`
                        : `${baseUrlImg}/logo/${agentSkin}.svg`
                    }
                    alt=""
                  />
                </>
              )}
              {(role == "support" || role == "main_admin") &&
              activeSkinId !== -1 &&
              activeSkinId !== undefined ? (
                <>
                  <div className="admin-header-logo">
                    {" "}
                    <img
                      className={menuSkinVisible ? "icon" : "logo-" + activeSkinId}
                      alt={`logo-${activeSkinId}`}
                      src={
                        menuSkinVisible
                          ? `${baseUrlImg}/icon/${activeSkinName}-icon.svg`
                          : `${baseUrlImg}/logo/${activeSkinName}.svg`
                      }
                    />
                    {/* <span>
                    {" "}
                    {role == "support"
                      ? "SUPPORT PANNEL"
                      : "SERVICES ADMIN PANNEL"}{" "}
                  </span> */}
                  </div>
                </>
              ) : (
                <span>
                  {(role == "support" || role == "main_admin") && (
                    <div
                      style={{ display: "flex", alignItems: "center" }}
                      className="admin-header-logo"
                    >
                      <img src={`${baseUrlImg}/logo/${skinName}.svg`} alt="" />
                      {/* <img
                      className={"logo-" + activeSkinId}
                      alt={`logo-${activeSkinId}`}
                      src={`${baseUrlImg}/logo/Apay-icon.svg`}
                    />
                    <span
                      style={{
                        textTransform: "capitalize",
                        fontStyle: "normal",
                        color: " #292D32",
                        fontWeight: 500,
                        fontSize: 28,
                      }}
                    >
                      Apay
                    </span> */}
                      {/* <span>
                    {" "}
                    {role == "support"
                      ? "SUPPORT PANNEL"
                      : "SERVICES ADMIN PANNEL"}{" "}
                  </span> */}
                    </div>

                    // <>
                    //   <span>
                    //     {role === "support"
                    //       ? accountInfo.profile.username === "support_prenotazioni"
                    //         ? "Luce&Gas"
                    //         : "Support"
                    //       : "Admin"}
                    //   </span>
                    //   <span>Panel</span>
                    // </>
                  )}
                </span>
              )}
            </a>
          </div>

          <div className="menu-section" style={{ marginTop: 10, marginBottom: 10 }}>
            Menu Principale
          </div>
          {/* Skins Menu */}
          {(role === "main_admin" || role === "support") && (
            <Menu
              selectedKeys={selectedSkinKey}
              mode="inline"
              defaultOpenKeys={["sub1"]}
            >
              <SubMenu
                key="sub1"
                title={
                  <span>
                    <img src={require("../../../assets/images/icons/skins.svg")} />
                    <span>Skins</span>
                  </span>
                }
              >
                <Menu.Item
                  key={-1}
                  onClick={(e) => {
                    setActiveSkinName("")
                    setActiveSkinId(-1)
                    setSelectedSkinKey(["-1"])
                  }}
                >
                  <div>
                    <img
                      className="skin-icons"
                      src={require("../../../assets/images/icons/category.svg")}
                      style={{ marginRight: 14, width: 24, height: 24, marginLeft: -2  }}
                    />
                    TUTTI
                  </div>
                </Menu.Item>
                {skinList &&
                  Array.isArray(skinList) &&
                  skinList.map((skin) => (
                    <Menu.Item
                      key={skin.id}
                      onClick={(e) => handleClickSkin(skin, e)}
                    >
                      <div style={{ textTransform: "capitalize" }}>
                        <img
                          className="skin-icons"
                          src={`${baseUrlImg}/icon/${skin?.username}-icon.svg`}
                          alt=""
                        />
                        {skin.username}
                      </div>
                    </Menu.Item>
                  ))}
              </SubMenu>
            </Menu>
          )}

          {/* Navigation Menu */}
          <Menu selectedKeys={selectedNavKey} mode="inline">
            {accessibleMenuItems.map((item) => {
              if (item.isSection) {
                return (
                  <div key={item.key} className="menu-section">
                    {item.label}
                  </div>
                )
              } else {
                return (
                  <Menu.Item
                    key={item.key}
                    onClick={() => {
                      if (item.onClick) {
                        item.onClick()
                      } else {
                        handleNavigation(item.path)
                      }
                    }}
                  >
                    <span>
                      {item.icon}
                      <span
                        style={
                          item.key === "panic-mode" && item.label === "Panic Mode"
                            ? { color: "red" }
                            : {}
                        }
                      >
                        {item.label}
                      </span>
                    </span>
                  </Menu.Item>
                )
              }
            })}
          </Menu>
          <div
            id="PWA"
            style={{ marginTop: "30px", marginBottom: "30px", cursor: "pointer" }}
          >
            <img src={`${baseUrlImg}/logo/pwa.svg`} height={45} />
          </div>
        </div>
        <Button onClick={handleLogout} className="logout-btn" icon="logout">
          Logout
        </Button>
      </div>
    </>
  )
}

const mstp = (state) => ({
  screenWidth: state.main.screenWidth,
  skinList: state.auth.skinList,
  activeSkinId: state.main.activeSkinId,
  activeSkinName: state.main.activeSkinName,
  accountInfo: state.auth.accountInfo,
  screenWidth: state.main.screenWidth,
})

export default connect(mstp, { ...MainActions, ...AuthActions })(
  withRouter(AdminMenu),
)
